import React from 'react'
import { tools, languages } from './data/resume_data'
import Bar from '../components/Bar.js'
import { motion } from 'framer-motion'

const Resume = () =>{
       const resume_variants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
               transition : {
                delay: 0.2, transition:0.6
        }
    },
       exit: {
        opacity:0,
        transition : {
            ease: 'easeInOut'
        }
    }
}
    return(
        <motion.div class="container resume"
        variants = {resume_variants}
            initial ='hidden'
            animate = 'visible'
            exit = 'exit'
        >
            <div className='row'>
                <div className="col-lg-6 resume-card">
                    <h4 className="resume-card__heading">
                        Education
                    </h4>
                <div className="resume-card__body">
                    <h5 className="resume-card__title">
                        BSC Computer Science
                    </h5>
                    <p className="resume-card__name">
                        Africa Nazarene University (2016 - 2020)
                    </p>
                    <p className="resume-card__details">Interested in continual growth through continual practice and building projects</p>
                    </div>
                </div>
                <div className="col-lg-6 resume-card">
                    <h4 className="resume-card__heading">
                        Experience
                    </h4>
                <div className="resume-card__body">
                    <h5 className="resume-card__title">
                        QA Analyst Assistant at Pajat Solutions Ltd.
                    </h5>
                    <p className="resume-card__name">
                        Present
                    </p>
                    <p className="resume-card__details">I work on developing acceptance tests and usability tests for the company software Poimapper</p>
                    </div>
                </div>
            </div> 
            <div className='row'>
                <div className="col-lg-6 resume-languages">
                    <h5 className="resume-language__heading">
                        Language and Framework
                    </h5>
                    <div className='resume-language__body'>
                        {
                            languages.map(language =>
                                <Bar value = {language}/>
                                )
                        }
                        </div>
                </div>
                <div className="col-lg-6 resume-languages">
                    <h5 className="resume-language__heading">
                        Tools and Softwares
                    </h5>
                    <div className='resume-language__body mt-3'>
                        {
                              tools.map(tool =>
                                <Bar value = {tool}/>
                                )
                        }
                        </div>
                </div>
            </div>
        </motion.div>
    )
}
export default Resume;